/**
 * Web Style Import
 *
 */

import './style/dnb-drawer.scss'
